



import { Component, Vue } from 'vue-property-decorator';
@Component({
	name: 'IndexPortfolio',
})
export default class IndexPortfolio extends Vue {}
